import React from 'react'
import style from './style.module.scss'
import ButtonWhiteLink from '../../design/Form/ButtonWhiteLink'

const ScheduleKickOffCallLeft = ({ appID }) => {
  const v2AuthFormContainerClasses = `${style.v2AuthFormContainer1} col-xl-6 col-md-12 col-xs-12 col-sm-12 p-0`

  return (
    <div className="create-application-wrapper">
      <div className={style.CreateApplicationWrapper}>
        <div className={style.CreateApplicationWrapperInner}>
          <div className={v2AuthFormContainerClasses}>
            <div className={style.formWrapper} style={{ width: '400px', height: '440px' }}>
              <div className={style.wrapperTitle}>Get started with expert guidance</div>
              <div className={style.wrapperDesc}>
                Our dedicated onboarding team is here to <br />
                brainstorm your specific use case and co-create a <br />
                solution that perfectly fits your needs. Leverage <br />
                their solution engineering expertise to tailor your <br />
                CometChat implementation for faster go-live.
              </div>
              <div className={style.wrapperSubText}>
                Pick a time slot and schedule your kick-off call.
              </div>
              <div className={style.wrapperSubText2}>We’re on the other side of the calendar.</div>
              <div>
                <ButtonWhiteLink
                  buttonText="Skip for now"
                  to={appID ? `/app/${appID}/overview` : '/apps'}
                  buttonStyles={{ width: '95%', height: '44px' }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ScheduleKickOffCallLeft
